import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { logOut } from "../../store/auth/authActions";
import "./style/finalizeWithLoginStyle.scss";
import "../../../style/alerts.scss";
import "../../../style/buttons.scss";
import "../../../style/feature.scss";
import InvoiceButtons from "./InvoiceButtons";
import { SubmitHandler, useForm, get } from "react-hook-form";
import { InputsFinalize } from "./FinalizeNoLogin";
import BasketSummary from "./BasketSummary";
import { FormElementModel } from "../../models/FormElementModel";
import { invoiceForm } from "./inputsForm/InputPayFormModels";
import EATextField from "../shared/TextField/EATextField";
import EANipInput from "../shared/NipInput/EANipInput";
import { useCountryCodes } from "./hooks/useCountryCodes";
import useMyAccount from "../MyAccount/hooks/useMyAccount";
import EcardButton from "./ecardPayment/EcardButton";
import EcardSummary from "./ecardPayment/EcardSummary";
import useFinalizeManager from "./hooks/useFinalizeManager";
import { PaymentLogos } from "../../../features/PaymentLogo";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import useFacility from "../../../utils/hooks/useFacility";
import RecipientAndPurchaserForm from "./RecipientAndPurchaserForm";
import EAButton from "../shared/Buttons/EAButton";
import ConsentInputs from "./ConsentInputs/ConsentInputs";
import Timer from "./Timer";
import TTPayCheckoutNotice from "./TTPayCheckoutNotice";
import { gaEvent } from "../../../utils/Analitics/ga";
import { canSendToFacebookPixel, canSendToGA } from "../../../utils/Analitics/analiticsConfigByFacility";
import { GA_BEGIN_CHECKOUT } from "../../../utils/Analitics/gaEventsConsts";
import { sendBeginCheckoutEvent, convertBasketToBeginCheckoutFormat } from "../../../utils/Analitics/GtmEvents";
import { BasketItem } from "../../models/BasketItem";
import SubmitButton from "./SubmitButton";
import useNewsletterConfirmation from "../NewsletterConfirmation/useNewsletterConfirmation";

interface IProps {
  onPayTransaction: (value: InputsFinalize) => void;
  onSaveReservation: (value: InputsFinalize) => void;
  alertPayment: string;
  total: number;
  paymentUrl: string;
  loader: boolean;
  basket: BasketItem[];
  promoMessage: string;
  currentPromoCode: string;
  submitButtonTitle?: string;
  setStep?: (index: number) => void;
}

const FinalizeWithLogin: React.FC<IProps> = ({
  onPayTransaction,
  onSaveReservation,
  alertPayment,
  total,
  paymentUrl,
  loader,
  basket,
  promoMessage,
  currentPromoCode,
  submitButtonTitle,
  setStep,
}: IProps) => {
  const dispatch = useDispatch();
  const userData = useSelector((state: State) => state.auth.userData);
  const isLoggedIn = useSelector((state: State) => state.auth.isLoggedIn);
  const [invoiceType, setInvoiceType] = useState<
    "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice"
  >("noInvoice");
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();
  const { eCardPaymnet, alert } = useFinalizeManager(() => {});
  const { sendInvite } = useNewsletterConfirmation();
  const facilityIds = useFacility();
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const { countryCodes, hasError: countryCodesError } = useCountryCodes();
  const isFreeOrder = total <= 0;
  const showInvoiceOptions = saleConfiguration.invoiceActive && !isFreeOrder;

  useMyAccount();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm<InputsFinalize>({
    defaultValues: userData,
  });

  // const handleRefreshBasket = async () => {
  //   //FAKOWE DODAWANIE I USUWANIE KOSZKA TYLKO ABY WYELIMINOWAC BLAD Index: 0 Size: 0
  //   // KOMENTARZUJE PO ROZMOWIE Z DAWIDEM
  //   const { result } = await post(ADD_TO_BASKET_URL, { facilityIds: `0,${facilityIds}` });
  //   await post(REMOVE_ITEM_BASKET_URL, { idx: result.length - 1 });
  // };

  useEffect(() => {
    reset(userData);
    //eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    if (isFreeOrder) {
      setInvoiceType("noInvoice");
    }
  }, [isFreeOrder]);

  // Po wylogowaniu się z tego ekranu wracamy do kroku wyboru logowania/rejestracji/zakupu bez rejestracji,
  // aby użytkownik nie zostawał na ekranie z pustymi danymi i widział efekt kliknięcia "Wyloguj się".
  useEffect(() => {
    if (!isLoggedIn) {
      setStep?.(3);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  // useEffect(() => {
  //   handleRefreshBasket();
  //   //eslint-disable-next-line
  // }, []);

  const handleRegistration: SubmitHandler<InputsFinalize> = async (data) => {
    // Czyszczenie pól faktury firmowej gdy nie wybrano faktury na firmę
    const cleanedData: InputsFinalize = {
      ...data,
      NIP: invoiceType === "companyInvoice" ? data.NIP : "",
      companyName: invoiceType === "companyInvoice" ? data.companyName : "",
      nipCountryCode: invoiceType === "companyInvoice" ? data.nipCountryCode : undefined,
    };

    // Zapisujemy stan koszyka lokalnie przed wykonaniem akcji
    const basketSnapshot = [...basket];
    const totalSnapshot = total;
    const promoCodeSnapshot = currentPromoCode;

    analiticsBeginCheckout(basketSnapshot, totalSnapshot, promoCodeSnapshot);

    // Guard to prevent multiple submissions, particularly for free orders (paymentUrl === "")
    setHasSubmitted(true);

    // Zapis do newslettera MUSI zdążyć przed saveReservation/acceptTransaction — te po
    // sukcesie natychmiast przekierowują całą stronę (parent) do bramki płatności, co
    // niszczy dokument i ucina wszystkie w locie/oczekujące requesty. Stąd await tutaj,
    // zamiast odpalać to niezależnie z opóźnieniem gdzieś obok. Ale musi to być best-effort
    // — sendInvite używa "gołego" post() bez obsługi błędów, więc jego wyjątek (np. sieć,
    // nietypowa odpowiedź serwera) nie może ubić całego checkoutu.
    if (data.allowMailing && data.email) {
      try {
        await sendInvite(facilityIds, data.email);
      } catch (e) {
        // Ignorujemy — zapis do newslettera nie może zablokować zakupu.
      }
    }

    if (isFreeOrder) {
      onPayTransaction({ ...cleanedData, createInvoice: false });
    } else if (invoiceType === "recipientAndPurchaserInvoice") {
      onSaveReservation({ ...cleanedData, createInvoice: true });
    } else {
      onPayTransaction({ ...cleanedData, createInvoice: invoiceType !== "noInvoice" });
    }

    // pixelAddBasket();
  };

  const [paymentType, setPaymentType] = useState<string>("online");
  const handleSetPayment = (type: string) => {
    setPaymentType(type);
  };

  const analiticsBeginCheckout = (
    basketSnapshot: any[],
    totalSnapshot: number,
    promoCodeSnapshot: string | undefined,
  ) => {
    // Calculate total from basket if needed
    const calculatedTotal = basketSnapshot.reduce((sum, item) => sum + item.price * item.qnt, 0);
    const eventValue = totalSnapshot > 0 ? totalSnapshot : calculatedTotal;

    if (canSendToFacebookPixel(facilityIds)) {
      ReactPixel.fbq("track", "basketValueBeforePayU", {
        value: eventValue,
        currency: "PLN",
      });
    }

    // Fix GA Event structure for ecommerce tracking
    if (canSendToGA(facilityIds)) {
      gaEvent(
        facilityIds,
        "ecommerce",
        GA_BEGIN_CHECKOUT,
        {
          event_category: "ecommerce",
          currency: "PLN",
          value: eventValue,
          items: basketSnapshot.map((item: any) => ({
            item_id: item.assortIds.replace(/^0,\+/, ""),
            item_name: item.assortName || "Produkt",
            price: item.price,
            quantity: item.qnt,
          })),
        },
        "begin_checkout",
      );
    }

    // Wysyłanie GTM begin_checkout event
    try {
      const promoCode = promoCodeSnapshot && promoCodeSnapshot.length > 0 ? promoCodeSnapshot : undefined;
      const beginCheckoutData = convertBasketToBeginCheckoutFormat(basketSnapshot, eventValue, promoCode);
      sendBeginCheckoutEvent(facilityIds, beginCheckoutData);
    } catch (error) {
      console.error("Error sending GTM begin_checkout event:", error);
    }
  };

  return (
    <div>
      <form className="finalize-no-login flex-between" onSubmit={handleSubmit(handleRegistration)}>
        <div className="basket-box shadow border">
          {Boolean(userData.b2bType) ? <h3>{t("zakladasz_zamowienie_na")}</h3> : <h3>{t("jestes_zalogowany")}</h3>}

          <div className="form form_looged">
            {!Boolean(userData.b2bType) && <input type="text" value={userData.firstName} />}
            <input type="text" value={userData.email} />
            {!Boolean(userData.b2bType) && <input type="text" value={userData.phone} />}
          </div>

          {!Boolean(userData.b2bType) && (
            <>
              <EAButton title={t("wyloguj_sie")} onClick={() => dispatch(logOut())} variant="outlined" />

              {showInvoiceOptions && (
                <React.Fragment>
                  {paymentType !== "ecard" && (
                    <>
                      <h4>{t("faktura")}</h4>

                      <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
                    </>
                  )}
                </React.Fragment>
              )}
            </>
          )}
        </div>

        <div className="basket-box shadow border">
          {showInvoiceOptions && invoiceType !== "noInvoice" && (
            <div>
              {invoiceType === "recipientAndPurchaserInvoice" ? (
                <RecipientAndPurchaserForm
                  register={register}
                  errors={errors}
                  control={control}
                  setValue={setValue}
                  countryCodes={countryCodes}
                  countryCodesError={countryCodesError}
                />
              ) : (
                <>
                  <h3>{t("dane_do_faktury")}</h3>
                  <div className={"inputs-customer-invoice"}>
                    {invoiceForm(register, invoiceType === "companyInvoice").map(
                      (item: FormElementModel, index: number) => (
                        <React.Fragment key={index}>
                          {item.name === "street" && invoiceType === "companyInvoice" && (
                            <EANipInput
                              control={control}
                              name="NIP"
                              countryCodeFieldName="nipCountryCode"
                              setValue={setValue}
                              errors={errors}
                              label={t("nip")}
                              countries={countryCodes}
                              showCountrySelect={!countryCodesError}
                              fullWidth
                            />
                          )}
                          {item.name && (
                            <EATextField
                              label={item.text}
                              name={item.name}
                              type={item.type as "text" | "email" | "password" | "number"}
                              placeholder={item.placeholder}
                              register={item.register}
                              error={!!get(errors, item.name)}
                              helperText={get(errors, item.name)?.message}
                              fullWidth
                              inputMaxLength={item.inputMaxLength}
                            />
                          )}
                        </React.Fragment>
                      ),
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {(isFreeOrder || invoiceType === "noInvoice") && (
            <ConsentInputs
              errors={errors}
              control={control}
              setValue={setValue}
              title={t("zgody")}
              newsletter={true}
            />
          )}
        </div>

        <div className="basket-box shadow border">
          {showInvoiceOptions && invoiceType !== "noInvoice" && (
            <ConsentInputs
              errors={errors}
              control={control}
              setValue={setValue}
              title={t("zgody")}
              newsletter={true}
            />
          )}
          {paymentType === "online" ? (
            <>
              <BasketSummary total={total} />

              {alertPayment.length > 2 && <div className="alert alert-red">{alertPayment}</div>}

              <SubmitButton
                loader={loader}
                paymentUrl={paymentUrl}
                hasSubmitted={hasSubmitted}
                submitButtonTitle={submitButtonTitle}
              />
              <Timer />
              <PaymentLogos />

              <EcardButton handleSetPayment={handleSetPayment} setInvoiceType={setInvoiceType} />
              <TTPayCheckoutNotice />
            </>
          ) : (
            <>
              <EcardSummary eCardPaymnet={eCardPaymnet} handleSetPayment={handleSetPayment} alert={alert} />
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default FinalizeWithLogin;
